import React, { useContext } from 'react';
import numberToLocaleNumber from '../../../global/js/numbers';
import SearchContext from '../data/FunnelbackContext';

function ListItem({ page, prevStart, nextStart, currentPage, numRanks, updateParams, prev, next }) {
    const isCurrent = page === currentPage;

    const startRank = (page - 1) * numRanks + 1 || 1;
    const href = '?';

    const listClasses = [
        'funnelback-instant-search-pagination__item',
        isCurrent ? 'funnelback-instant-search-pagination__item--current' : '',
        prev ? 'funnelback-instant-search-pagination__item--previous' : '',
        next ? 'funnelback-instant-search-pagination__item--next' : '',
    ].join(' ');

    let ariaLabel = next ? `Go to page ${currentPage - 1}` : `${isCurrent ? 'Current page, go' : 'Go'} to page ${page}`;
    ariaLabel = prev ? `Go to page ${currentPage + 1}` : ariaLabel;

    let pageRank = next ? nextStart : startRank;
    pageRank = prev ? prevStart : pageRank;

    return (
        <li className={listClasses}>
            <a
                href={href}
                rel="nofollow"
                aria-label={ariaLabel}
                aria-current={isCurrent}
                onClick={updateParams({ start_rank: pageRank, num_ranks: numRanks })}
                className="funnelback-instant-search-pagination__link"
            >
                {next || prev ? (
                    <>
                        {next ? 'Next' : ''}
                        <svg aria-hidden className="funnelback-instant-search-pagination__icon">
                            <use href="#chevron" />
                        </svg>
                        {prev ? 'Prev' : ''}
                    </>
                ) : (
                    numberToLocaleNumber(page)
                )}
            </a>
        </li>
    );
}

/**
 * Create pagination component.
 *
 * @returns {JSX.Element|null}
 * @constructor
 */
function Pagination() {
    const {
        isFetching,
        updateParams,
        resultsSummary: { pages, prevStart, nextStart, currentPage, numRanks },
    } = useContext(SearchContext);

    if (isFetching) {
        return (
            <nav
                className="funnelback-instant-search-pagination no-wysiwyg"
                role="navigation"
                aria-label="Search page pagination navigation"
            >
                <div className="sr-only">Loading...</div>
                <ol className="funnelback-instant-search-pagination__list">
                    {[...Array(5)].map((item, index) => (
                        <li
                            className="funnelback-instant-search-pagination__item--loading"
                            // eslint-disable-next-line react/no-array-index-key
                            key={`result-${index}`}
                        />
                    ))}
                </ol>
            </nav>
        );
    }

    // hide pagination if we have only one page
    if (pages === undefined || pages.length <= 1) {
        return null;
    }

    // Pages is array of shifting range indexes. By its deconstructing,
    // we are taking first element from array and assigning name first and
    // taking last item and assigning name last.
    const { 0: first, [pages.length - 1]: last } = pages;

    return (
        <nav className="funnelback-instant-search-pagination no-wysiwyg" role="navigation" aria-label="Search page pagination navigation">
            <ol className="funnelback-instant-search-pagination__list">
                {currentPage > first && (
                    <ListItem prev updateParams={updateParams} prevStart={prevStart} currentPage={currentPage} page={first} />
                )}
                {pages.map((page) => (
                    <ListItem
                        key={`page-key-${page}`}
                        page={page}
                        pages={pages}
                        prevStart={prevStart}
                        nextStart={nextStart}
                        currentPage={currentPage}
                        numRanks={numRanks}
                        updateParams={updateParams}
                    />
                ))}
                {currentPage < last && (
                    <ListItem next updateParams={updateParams} nextStart={nextStart} currentPage={currentPage} page={last} />
                )}
            </ol>
        </nav>
    );
}

export default Pagination;
